'use strict';

var _ = require('lodash');
var ApplicableSeasonsLoadingService = function ApplicableSeasonsLoadingService($q, dataRetrieverConstantsService, dataRetrieverService, SearchCriteriaRule, gridDropdownPopulateService) {
  var C = dataRetrieverConstantsService;
  var domainNames = {};
  domainNames[C.MARKET_SCREEN] = 'UntruncatedMarketDemand';
  domainNames[C.FLIGHT_SCREEN] = 'LegShowUpMetrics';
  function buildSearchRules(markets, screen) {
    return [new SearchCriteriaRule({
      category: 'Location',
      field: 'custom:market',
      leftOperand: markets,
      operator: '='
    }), new SearchCriteriaRule({
      category: 'domainName',
      field: 'domainName',
      leftOperand: domainNames[screen],
      operator: '='
    }), new SearchCriteriaRule({
      category: 'active',
      field: 'active',
      leftOperand: true,
      operator: '='
    })];
  }
  function retrieveData(markets, screen) {
    var applicableSeasonsDataRetriever = dataRetrieverService.getDataRetriever(screen, C.APPLICABLE_SEASONS);
    applicableSeasonsDataRetriever.defaultSortDefer = $q.all();
    applicableSeasonsDataRetriever.defaultSortCriteriaPromise = applicableSeasonsDataRetriever.defaultSortDefer.promise;
    applicableSeasonsDataRetriever.setCustomSearchCriteriaRules(buildSearchRules(markets, screen));
    return applicableSeasonsDataRetriever.retrieveComponentData();
  }
  function initDropdownValues(markets, screen) {
    _.forEach(markets, function (market) {
      gridDropdownPopulateService.setApplicableSeasons(market + ':' + domainNames[screen], []);
    });
  }
  function resetSeasons() {
    gridDropdownPopulateService.resetApplicableSeasons();
  }
  function checkLoadedDropdownValues(markets, screen) {
    var result = true;
    _.forEach(markets, function (market) {
      if (!gridDropdownPopulateService.getApplicableSeasons(market + ':' + domainNames[screen])) {
        result = false;
      }
    });
    return result;
  }
  function loadApplicableSeasons(markets, screen) {
    if (markets && domainNames[screen] && !checkLoadedDropdownValues(markets, screen)) {
      initDropdownValues(markets, screen);
      retrieveData(markets, screen).then(function (applicableSeasonsData) {
        _.forEach(applicableSeasonsData, function (seasonData, legKey) {
          gridDropdownPopulateService.setApplicableSeasons(legKey + ':' + domainNames[screen], seasonData);
        });
      });
    }
  }
  return {
    buildSearchRules: buildSearchRules,
    retrieveData: retrieveData,
    checkLoadedDropdownValues: checkLoadedDropdownValues,
    loadApplicableSeasons: loadApplicableSeasons,
    resetSeasons: resetSeasons
  };
};
ApplicableSeasonsLoadingService.$inject = ['$q', 'DataRetrieverConstantsService', 'DataRetrieverService', 'SearchCriteriaRuleFactory', 'GridDropdownPopulateService'];
module.exports = ApplicableSeasonsLoadingService;